import React, { Component } from "react";
import AccountRegisterPanel from "container/account/signUp/AccountRegisterPanel";
import AccountCreatePanel from "container/account/signUp/AccountCreatePanel";
import GaHelper from "lib/gaHelper";
import PixelHelper from "lib/pixelHelper";
import PropTypes from "prop-types";

class RootSignUp extends Component {
  static propTypes = {
    toggleModeFn: PropTypes.func.isRequired,
    goNextUrl: PropTypes.func.isRequired,
    goToSocialPage: PropTypes.func.isRequired
  };

  state = {
    mode: "register",
    email: null,
    password: null
  };

  handleCognitoSignUpComplete = ({ email, password }) => {
    this.setState({ mode: "create", email, password });

    GaHelper.setGAEvent({ type: "ma_view_sign_up_form_2nd" });
  };

  render() {
    const { toggleModeFn, goNextUrl, goToSocialPage } = this.props;
    const { mode, email, password } = this.state;

    return (
      <div>
        <div>
          {mode === "register" && (
            <AccountRegisterPanel
              onCognitoSignUpComplete={this.handleCognitoSignUpComplete}
              onModeToggleBtnClick={toggleModeFn}
              goToSocialPage={goToSocialPage}
            />
          )}
          {mode === "create" && (
            <AccountCreatePanel
              email={email}
              password={password}
              goNextUrl={goNextUrl}
            />
          )}
        </div>
      </div>
    );
  }

  componentDidMount() {
    GaHelper.setGAEvent({ type: "ma_view_sign_up_form_1st" });
    PixelHelper.setPixelEvent({ type: "enterSignUp" });
  }
}

export default RootSignUp;
